
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const offers = [
  {
    id: 1,
    technicianName: 'أحمد محمد',
    rating: 4.9,
    reviews: 156,
    price: '180',
    arrivalTime: '30',
    experience: '8 سنوات',
    completedJobs: 245,
    image: 'https://public.readdy.ai/ai/img_res/fb9f3c4720c66a4e5914734b1fd15792.jpg'
  },
  {
    id: 2,
    technicianName: 'خالد العتيبي',
    rating: 4.8,
    reviews: 134,
    price: '200',
    arrivalTime: '45',
    experience: '6 سنوات',
    completedJobs: 198,
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20technician%20portrait%20in%20work%20uniform%2C%20confident%20look%2C%20professional%20appearance%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20clean%20background&width=200&height=200&seq=tech2&orientation=squarish'
  },
  {
    id: 3,
    technicianName: 'محمد السالم',
    rating: 4.7,
    reviews: 112,
    price: '170',
    arrivalTime: '60',
    experience: '5 سنوات',
    completedJobs: 167,
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20technician%20portrait%20in%20work%20uniform%2C%20friendly%20expression%2C%20professional%20appearance%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20clean%20background&width=200&height=200&seq=tech3&orientation=squarish'
  },
  {
    id: 4,
    technicianName: 'عبدالله الشمري',
    rating: 4.9,
    reviews: 189,
    price: '190',
    arrivalTime: '40',
    experience: '7 سنوات',
    completedJobs: 223,
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20technician%20portrait%20in%20work%20uniform%2C%20professional%20smile%2C%20expert%20appearance%2C%20high%20quality%20photography%2C%20realistic%20style%2C%20clean%20background&width=200&height=200&seq=tech4&orientation=squarish'
  }
];

export default function PriceOffers() {
  const navigate = useNavigate();
  const [selectedOffer, setSelectedOffer] = useState<number | null>(null);

  const handleAccept = (offerId: number) => {
    setSelectedOffer(offerId);
    setTimeout(() => {
      navigate('/order-tracking');
    }, 500);
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-6">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6 rounded-b-[30px]">
        <div className="flex items-center gap-3 mb-4 animate-fadeIn">
          <button onClick={() => navigate(-1)} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <div className="flex-1">
            <h1 className="text-xl font-bold text-white">عروض الأسعار</h1>
            <p className="text-white/80 text-sm mt-1">اختر العرض المناسب لك</p>
          </div>
        </div>

        {/* Stats */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 animate-slideUp">
          <div className="flex items-center justify-around">
            <div className="text-center">
              <div className="text-2xl font-bold text-white">{offers.length}</div>
              <div className="text-white/80 text-xs mt-1">عروض متاحة</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">30</div>
              <div className="text-white/80 text-xs mt-1">دقيقة متوسط</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">4.8</div>
              <div className="text-white/80 text-xs mt-1">التقييم</div>
            </div>
          </div>
        </div>
      </div>

      {/* Offers List */}
      <div className="px-6 mt-6">
        <div className="space-y-4">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              className={`bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all animate-slideUp ${
                selectedOffer === offer.id ? 'ring-2 ring-[#2E7D32]' : ''
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="p-4">
                {/* Technician Info */}
                <div className="flex gap-3 mb-4">
                  <div className="relative">
                    <div className="w-16 h-16 rounded-full overflow-hidden">
                      <img
                        src={offer.image}
                        alt={offer.technicianName}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="absolute -bottom-1 -left-1 w-6 h-6 bg-[#2E7D32] rounded-full flex items-center justify-center border-2 border-white">
                      <i className="ri-checkbox-circle-fill text-white text-xs"></i>
                    </div>
                  </div>

                  <div className="flex-1">
                    <h3 className="font-bold text-[#212121] mb-1">{offer.technicianName}</h3>
                    <div className="flex items-center gap-2 mb-1">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-[#FBC02D] text-xs"></i>
                        <span className="text-sm font-semibold">{offer.rating}</span>
                      </div>
                      <span className="text-gray-400 text-xs">({offer.reviews} تقييم)</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-xs text-gray-500">
                        <i className="ri-briefcase-line ml-1"></i>
                        {offer.experience}
                      </span>
                      <span className="text-xs text-gray-500">
                        <i className="ri-checkbox-circle-line ml-1"></i>
                        {offer.completedJobs} طلب
                      </span>
                    </div>
                  </div>
                </div>

                {/* Price & Time */}
                <div className="bg-[#F6F6F6] rounded-xl p-3 mb-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <div className="w-10 h-10 bg-[#1565C0]/10 rounded-lg flex items-center justify-center">
                        <i className="ri-money-dollar-circle-line text-[#1565C0]"></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">السعر</div>
                        <div className="flex items-center gap-1">
                          <span className="text-lg font-bold text-[#1565C0]">{offer.price}</span>
                          <span className="text-xs text-gray-400">ر.س</span>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="w-10 h-10 bg-[#2E7D32]/10 rounded-lg flex items-center justify-center">
                        <i className="ri-time-line text-[#2E7D32]"></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">وقت الوصول</div>
                        <div className="flex items-center gap-1">
                          <span className="text-lg font-bold text-[#2E7D32]">{offer.arrivalTime}</span>
                          <span className="text-xs text-gray-400">دقيقة</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accept Button */}
                <button
                  onClick={() => handleAccept(offer.id)}
                  className={`w-full py-3 rounded-xl font-bold transition-all active:scale-[0.98] ${
                    selectedOffer === offer.id
                      ? 'bg-[#2E7D32] text-white'
                      : 'bg-[#1565C0] text-white hover:bg-[#1565C0]/90'
                  }`}
                >
                  {selectedOffer === offer.id ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-checkbox-circle-fill"></i>
                      تم القبول
                    </span>
                  ) : (
                    'قبول العرض'
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
